"use client"

import { SendToBack } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SendToBackIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SendToBackIcon = component(Icon)({ as: SendToBack })
